import { mode, transparentize } from '@chakra-ui/theme-tools';
const getBaseStyle = (props) => {
    const { colorScheme, theme } = props;
    return {
        color: mode('gray.600', 'white')(props),
        fontSize: 'sm',
        marginRight: 3,
        marginBottom: 0,
        lineHeight: '1.5rem',
        fontWeight: 'semibold',
        transition: 'all 0.25s',
        opacity: 1,
        _disabled: {
            color: mode(transparentize(`${colorScheme}.600`, 0.36)(theme), transparentize('white', 0.36)(theme))(props),
        },
    };
};
export default { baseStyle: getBaseStyle };
//# sourceMappingURL=form-label.js.map